import { MatrizIdentidadTiposCuestionariosProductosService } from './../../_services/matriz-identidad-tipos-cuestionarios-productos.service';
import { MatrizIdentidadTiposCuestionariosService } from './../../_services/matriz-identidad-tipos-cuestionarios.service';
import { MatrizIdentidadTiposCuestionariosProductos } from './../../_models/matriz-identidad-tipos-cuestionarios-productos';
import { ProductoService } from './../../_services/producto.service';
import { MetodosValidacionesIdentidad } from './../../_enums/enum';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NavService } from '../../_services/_nav.service';
import { PaqueteSeguros } from '../../_models/paquete-seguros';
import { PaqueteSegurosService } from '../../_services/paquete-seguros.service';
import { AppSettingService } from '../../_services/app-setting.service';
import { Plaga } from '../../_models/plaga';
import { PoliticasCredito } from '../../_models/politicas-credito';
import { Canal } from '../../_models/canal';
import { Lista } from '../../_models/lista';
import { ListaItem } from '../../_models/lista-item';
import { CanalService } from '../../_services/canal.service';
import { ListaService } from '../../_services/lista.service';
import { MatrizIdentidadService } from '../../_services/matriz-identidad.service';
import { forkJoin } from 'rxjs';
import { PaqueteSegurosSeguros } from '../../_models/paquete-seguros-seguros';
import { PaqueteSegurosSegurosPlanes } from '../../_models/paquete-seguros-seguros-planes';
import { Producto } from '../../_models/producto';
import { MatrizIdentidadTipoCuestionarioDto } from '../../_models/matriz-identidad-tipo-cuestionario-dto';

@Component({
  selector: 'app-matriz-identidad-editar',
  templateUrl: 'matriz-identidad-editar.component.html'
})

export class MatrizIdentidadEditarComponent implements OnInit {

  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  guardandoCuestionario = false;

  listCanes: Canal[] = [];
  lisCanales: SelectItem[];
  listTipoCliente: ListaItem[] = [];
  lisTipoCliente: SelectItem[];
  listModoAutenticacion: ListaItem[] = [];
  lisModoAutenticacion: SelectItem[];
  listaTiposCuestionarios: ListaItem[] = [];
  lisTiposCuestionarios: SelectItem[];
  listaProductos: Producto[] = [];
  lisProductos: SelectItem[];
  matrizIdentidad: any;
  matrizIdentidadTiposCuestionarios: any;
  matrizIdentidadTiposCuestionariosProductos: MatrizIdentidadTiposCuestionariosProductos;
  listaMatrizIdentidadTiposCuestionarios: any[] = [];
  listaMatrizIdentidadTiposCuestionariosProductos: MatrizIdentidadTiposCuestionariosProductos[] = [];
  listaMatrizIdentidadTipoCuestionarioConProducto: MatrizIdentidadTipoCuestionarioDto[];
  lisTiposCuestionariosHabilitados: MatrizIdentidadTipoCuestionarioDto[];
  listaMatrizIdentidad: any[] = [];
  tabSeleccionado = 'GENERAL';

  formulario: FormGroup;
  formularioCuestionario: FormGroup;
  columnas: any[];
  submitted = false;
  carTabla = true;
  cargandoCuestionario = false;
  carTablaCuestionario = false;
  validacionIdentidad = false;
  esConfronta = false;
  llaveExiste = false;

  constructor(private canalesServicio: CanalService,
    private listaService: ListaService,
    private matrizIdentidadService: MatrizIdentidadService,
    private route: ActivatedRoute,
    private fb: FormBuilder,
    private location: Location,
    private conServicio: ConfirmationService,
    private navServicio: NavService,
    public appSettingService: AppSettingService,
    private productoService: ProductoService,
    private matrizIdentidadTiposCuestionariosService: MatrizIdentidadTiposCuestionariosService,
    private matrizIdentidadTiposCuestionariosServiceProductos: MatrizIdentidadTiposCuestionariosProductosService) {
  }

  ngOnInit(): void {
    this.route.params.subscribe((params: Params) => {
      if ((params['id'] !== '' && params['id'] !== null && params['id'] !== undefined)) {

        this.matrizIdentidadService.obtenerPorId(params['id']).subscribe(matriz => {
          this.matrizIdentidad = matriz;
          this.cargarInformacionInicial();
        });
      } else {
        this.cargarInformacionInicial();
      }
    });
  }

  cargarInformacionInicial() {

    this.formulario = this.fb.group({
      idMatrizIdentidad: [this.matrizIdentidad ? this.matrizIdentidad.idMatrizIdentidad : null],
      idCanal: [this.matrizIdentidad ? this.matrizIdentidad.idCanal : null, [Validators.required]],
      idModoAutenticacion: [this.matrizIdentidad ? this.matrizIdentidad.idModoAutenticacion : null, [Validators.required]],
      idModoAutenticacionOpcional: [this.matrizIdentidad ? this.matrizIdentidad.idModoAutenticacionOpcional : null],
      idTipoCuestionario: [this.matrizIdentidad ? this.matrizIdentidad.idTipoCuestionario : null],
      indicadorMetodoOpcional: [this.matrizIdentidad ? this.matrizIdentidad.indicadorMetodoOpcional : false],
      idTipoCliente: [this.matrizIdentidad ? this.matrizIdentidad.idTipoCliente : null, [Validators.required]],
      indicadorTomaDatos: [this.matrizIdentidad ? this.matrizIdentidad.indicadorTomaDatos : false],
      indicadorValidacionIdentidad: [this.matrizIdentidad ? this.matrizIdentidad.indicadorValidacionIdentidad : false],
      indicadorHabilitado: [this.matrizIdentidad ? this.matrizIdentidad.indicadorHabilitado : true, [Validators.required]],
      indicadorObligatorio: [this.matrizIdentidad ? this.matrizIdentidad.indicadorObligatorio : false],
    });

    forkJoin(this.canalesServicio.listadoCanalesHabilitados(),
      this.listaService.getMasterDetails('ListasTiposClientes'),
      this.listaService.getMasterDetails('ListasModosAutenticaciones'),
      this.matrizIdentidadService.listado(),
      this.listaService.getMasterDetails('ListasTiposCuestionarios'),
      this.productoService.listadoHabilitados()
    ).subscribe(([canales, tipoCliente, modoAutenticacion, matrizIdentidad, tiposCuestionarios, productos]) => {
      productos = productos.sort(function (a, b) {
        return a.orden - b.orden;
      });
      this.listCanes = canales;
      this.listTipoCliente = tipoCliente;
      this.listModoAutenticacion = modoAutenticacion;
      this.listaMatrizIdentidad = matrizIdentidad;
      this.listaTiposCuestionarios = tiposCuestionarios;
      this.listaProductos = productos;
      this.lisCanales = [];
      canales.map((s: Canal) => {
        this.lisCanales.push({ label: s.nombre, value: s.idCanal });
      });
      this.lisTipoCliente = [];
      tipoCliente.map((s: ListaItem) => {
        this.lisTipoCliente.push({ label: s.nombre, value: s.idLista });
      });
      this.lisModoAutenticacion = [];
      modoAutenticacion.map((s: ListaItem) => {
        this.lisModoAutenticacion.push({ label: s.nombre, value: s.idLista });
      });
      this.lisTiposCuestionarios = [];
      tiposCuestionarios.map((s: ListaItem) => {
        this.lisTiposCuestionarios.push({ label: s.nombre, value: s.idLista });
      });
      this.lisProductos = [];
      productos.map((s: Producto) => {
        this.lisProductos.push({ label: s.nombre, value: s.idProducto });
      });
      this.validarMetodoEspecifico();
      this.carInformacionInicial = false;
    });

  }

  validarMetodoEspecifico() {
    const confrontaUltra = this.listModoAutenticacion.find((x) => x.idLista === this.f.idModoAutenticacion.value && x.codigo === MetodosValidacionesIdentidad.CONFRONTA);

    if (!confrontaUltra) {
      this.esConfronta = false;
      return;
    }
    this.cargarInformacionTiposCuestionarios();
    this.esConfronta = true;
    this.f.idTipoCuestionario.setValidators([Validators.required]);
    this.f.idTipoCuestionario.updateValueAndValidity();
  }

  cargarFormularioCuestionario() {
    this.formularioCuestionario = this.fb.group({
      idMatrizIdentidadTipoCuestionario: [this.matrizIdentidadTiposCuestionarios ? this.matrizIdentidadTiposCuestionarios.idMatrizIdentidadTipoCuestionario : null],
      idMatrizIdentidad: [this.matrizIdentidad ? this.matrizIdentidad.idMatrizIdentidad : null, [Validators.required]],
      idTipoCuestionario: [null, [Validators.required]],
      idsProductos: [null, [Validators.required]],
      indicadorHabilitado: [true, [Validators.required]],
    });
  }

  cargarColumnasTiposCuestionarios() {
    this.columnas = [
      { field: 'matrizIdentidadTiposCuestionarios.nombreTipoCuestionario', header: this.navServicio.buscarMensaje('MATRIZIDENTIDAD.LBL_TIPODECUESTIONARIO'), sort: true },
      { field: 'nombresProductos', header: this.navServicio.buscarMensaje('MATRIZIDENTIDAD.LBL_PRODUCTOS'), sort: true },
      { field: 'det', header: this.navServicio.buscarMensaje('LBL_ACCIONES'), sort: false }
    ];
  }

  cargarInformacionTiposCuestionarios() {
    this.cargandoCuestionario = true;
    this.carTablaCuestionario = true;
    this.cargarFormularioCuestionario();
    this.cargarColumnasTiposCuestionarios();
    forkJoin(
      this.matrizIdentidadTiposCuestionariosService.listadoPorIdMatrizIdentidadConProducto(this.matrizIdentidad.idMatrizIdentidad)
    ).subscribe(([matrizIdentidadTipoCuestionarioConProducto]) => {
      this.listaMatrizIdentidadTipoCuestionarioConProducto = matrizIdentidadTipoCuestionarioConProducto;
      this.lisTiposCuestionariosHabilitados = this.listaMatrizIdentidadTipoCuestionarioConProducto.filter((x) => x.matrizIdentidadTiposCuestionarios.indicadorHabilitado);
      this.lisTiposCuestionariosHabilitados.map((x) => {
        const lisProductosNombres = [];
        x.matrizIdentidadTiposCuestionariosProductosList.map((producto) => {
          if (producto.indicadorHabilitado) {
            lisProductosNombres.push(producto.producto);
          }
        });
        x.nombresProductos = lisProductosNombres.join(' - ');
      });
      this.carTablaCuestionario = false;
      this.cargandoCuestionario = false;
    });
  }

  validarCheckOpcional() {
    if (this.f.indicadorMetodoOpcional.value) {
      this.f.idModoAutenticacionOpcional.setValidators([Validators.required]);
      this.f.idModoAutenticacionOpcional.setValue(null);
      this.f.idModoAutenticacionOpcional.updateValueAndValidity();
    } else {
      this.f.idModoAutenticacionOpcional.setValidators(null)
      this.f.idModoAutenticacionOpcional.setValue(null);
      this.f.idModoAutenticacionOpcional.updateValueAndValidity();
    }
  }

  onSubmit() {
    this.submitted = true;
    this.validarLlaveNegocio();
    if (!this.llaveExiste && !this.f.indicadorTomaDatos.value && !this.f.indicadorValidacionIdentidad.value) {
      this.validacionIdentidad = true;
    } else {
      this.validacionIdentidad = false;
    }
    if (!this.llaveExiste && !this.validacionIdentidad && this.formulario.valid) {
      this.guardando = true;
      const formulario = this.formulario.getRawValue();
      formulario.indicadorObligatorio = formulario.indicadorTomaDatos ? formulario.indicadorObligatorio : false;
      if (formulario.idMatrizIdentidad) {
        this.matrizIdentidadService.actualizar(formulario).subscribe(matriz => {
          this.matrizIdentidad = matriz;
          this.submitted = false;
          this.guardando = false;
          this.navServicio.setMesage(2);
          this.location.back();
        });
      } else {
        this.matrizIdentidadService.crear(formulario).subscribe(matriz => {
          this.matrizIdentidad = matriz;
          this.f.idMatrizIdentidad.setValue(matriz.idMatrizValidacionIdentidad);
          this.submitted = false;
          this.guardando = false;
          this.navServicio.setMesage(1);
          this.location.back();
        });
      }
    }
  }

  async onSubmitCuestionario() {
    this.submitted = true;
    if (this.formularioCuestionario.valid) {
      this.conServicio.confirm({
        message: this.navServicio.buscarMensaje('MATRIZIDENTIDAD.MSG_GUARDARTIPOCUESTIONARIO'),
        header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: async () => {
          this.cargandoCuestionario = true;
          const registro = {} as any;
          registro.idMatrizIdentidad = this.fC.idMatrizIdentidad.value;
          registro.idMatrizIdentidadTipoCuestionario = this.fC.idMatrizIdentidadTipoCuestionario.value;
          registro.idsProductos = this.fC.idsProductos.value;
          registro.idTipoCuestionario = this.fC.idTipoCuestionario.value;
          registro.indicadorHabilitado = true;
          await this.guardarCuestionario(registro);
        },
        reject: () => {
        }
      });

    }
  }

  async guardarCuestionario(registro: any) {
    const existe = this.listaMatrizIdentidadTipoCuestionarioConProducto.find((x) => x.matrizIdentidadTiposCuestionarios.idCuestionario === registro.idTipoCuestionario);
    if (!existe) {
      const res = await this.matrizIdentidadTiposCuestionariosService.crear(registro).toPromise();
      const registrosBulk = [];
      registro.idsProductos.forEach((idProducto) => {
        const tipoCuestionarioProducto = {} as MatrizIdentidadTiposCuestionariosProductos;
        tipoCuestionarioProducto.idMatrizValidacionIdentidadCuestionarioProducto = res.idMatrizValidacionIdentidadCuestionarioProducto;
        tipoCuestionarioProducto.idProducto = idProducto;
        tipoCuestionarioProducto.indicadorHabilitado = true;
        registrosBulk.push(tipoCuestionarioProducto);
      })
      const resBulk = await this.matrizIdentidadTiposCuestionariosServiceProductos.bulk(registrosBulk).toPromise();
      this.showMessage('Exito', 'MATRIZIDENTIDAD.MSG_GUARDADOEXITOSO', 'success');
      this.submitted = false;
      this.cargarInformacionTiposCuestionarios();
    } else {
      this.listaMatrizIdentidadTiposCuestionariosProductos = existe.matrizIdentidadTiposCuestionariosProductosList;
      registro.idMatrizIdentidadTipoCuestionario = existe.matrizIdentidadTiposCuestionarios.idMatrizValidacionIdentidadCuestionarioProducto;
      const res = await this.matrizIdentidadTiposCuestionariosService.actualizar(registro).toPromise();
      const registrosBulk = [];
      this.listaMatrizIdentidadTiposCuestionariosProductos.map((tipoCuestionarioProducto) => {
        const existe = registro.idsProductos.find((x) => x === tipoCuestionarioProducto.idProducto);
        if (existe) {
          tipoCuestionarioProducto.indicadorHabilitado = true;
        } else {
          tipoCuestionarioProducto.indicadorHabilitado = false;
        }
        registrosBulk.push(tipoCuestionarioProducto);
      });
      registro.idsProductos.map((y) => {
        const existe = registrosBulk.find(x => x.idProducto === y);
        if (!existe) {
          const tipoCuestionarioProducto = {} as MatrizIdentidadTiposCuestionariosProductos;
          tipoCuestionarioProducto.idMatrizValidacionIdentidadCuestionarioProducto = res.idMatrizValidacionIdentidadCuestionarioProducto;
          tipoCuestionarioProducto.idProducto = y;
          tipoCuestionarioProducto.indicadorHabilitado = true;
          registrosBulk.push(tipoCuestionarioProducto);
        }
      })
      const resBulk = await this.matrizIdentidadTiposCuestionariosServiceProductos.bulk(registrosBulk).toPromise();
      this.showMessage('Exito', 'MATRIZIDENTIDAD.MSG_GUARDADOEXITOSO', 'success');
      this.submitted = false;
      this.cargarInformacionTiposCuestionarios();
    }
  }

  abrirAcordeon(index: number) {
    switch (index) {
      case 0: {
        this.tabSeleccionado = 'GENERAL';
        break;
      }
      case 1: {
        this.tabSeleccionado = 'TIPOSCUESTIONARIOS';
        break;
      }

    }
  }

  regresar(dirty: boolean) {
    if (dirty) {
      this.conServicio.confirm({
        message: this.navServicio.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      });
    } else {
      this.location.back();
    }
  }

  cancelar(dirty: boolean) {
    if (dirty) {
      this.conServicio.confirm({
        message: this.navServicio.buscarMensaje('MSG_CANCELARCAMBIOS'),
        header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
        icon: 'fa fa-question-circle',
        accept: () => {
          this.resetearFormulario();
        },
        reject: () => {
        }
      });
    } else {
      this.resetearFormulario();
    }
  }

  resetearFormulario() {
    this.matrizIdentidadTiposCuestionarios = null;
    this.listaMatrizIdentidadTiposCuestionariosProductos = null;
    this.formularioCuestionario.reset();
    this.submitted = false;
  }

  editarTipoCuestionario(row: MatrizIdentidadTipoCuestionarioDto) {
    this.matrizIdentidadTiposCuestionarios = row.matrizIdentidadTiposCuestionarios;
    this.listaMatrizIdentidadTiposCuestionariosProductos = row.matrizIdentidadTiposCuestionariosProductosList;
    const lisIdsProductos = Array.from(this.listaMatrizIdentidadTiposCuestionariosProductos.filter((x) => x.indicadorHabilitado), x => x.idProducto);
    this.fC.idsProductos.setValue(lisIdsProductos);
    this.fC.idTipoCuestionario.setValue(this.matrizIdentidadTiposCuestionarios.idTipoCuestionario);
    this.fC.idMatrizIdentidadTipoCuestionario.setValue(this.matrizIdentidadTiposCuestionarios.idMatrizIdentidadTipoCuestionario);
  }

  inhabilitarRegistro(row: MatrizIdentidadTipoCuestionarioDto) {
    this.conServicio.confirm({
      message: this.navServicio.buscarMensaje('MATRIZIDENTIDAD.MSG_ELIMINARTIPOCUESTIONARIO'),
      header: this.navServicio.buscarMensaje('LBL_CONFIRMACION'),
      icon: 'fa fa-question-circle',
      accept: async () => {
        this.cargandoCuestionario = true;
        this.carTablaCuestionario = true;
        const registroAct = row.matrizIdentidadTiposCuestionarios;
        row.matrizIdentidadTiposCuestionariosProductosList.map((x) => x.indicadorHabilitado = false);
        const lisBulkAct = row.matrizIdentidadTiposCuestionariosProductosList;
        registroAct.indicadorHabilitado = false;
        await this.matrizIdentidadTiposCuestionariosService.actualizar(registroAct).toPromise();
        await this.matrizIdentidadTiposCuestionariosServiceProductos.bulk(lisBulkAct).toPromise();
        this.showMessage('Exito', 'MATRIZIDENTIDAD.MSG_ELIMINACIONEXITOSA', 'info');
        this.formularioCuestionario.reset();
        this.submitted = false;
        this.cargarInformacionTiposCuestionarios();
      },
      reject: () => {
      }
    });
  }



  get f() {
    return this.formulario.controls;
  }

  get fC() {
    return this.formularioCuestionario.controls;
  }


  validarLlaveNegocio() {
    const idMatrizIdentidad = (this.f.idMatrizIdentidad.value);
    const idCanal = this.f.idCanal.value;
    const idModoAutenticacion = this.f.idModoAutenticacion.value;
    const idTipoCliente = this.f.idTipoCliente.value;
    const dato1 = this.listaMatrizIdentidad.find(x => x.idCanal === idCanal && x.idModoAutenticacion === idModoAutenticacion && x.idTipoCliente === idTipoCliente);
    if (dato1 && dato1.idMatrizIdentidad !== idMatrizIdentidad) {
      this.llaveExiste = true;
    } else {
      this.llaveExiste = false;
    }
  }

  setearIndicadorObligatorio() {
    if (!this.f.indicadorTomaDatos.value) {
      this.f.indicadorObligatorio.setValue(true);
    }
  }


  private showMessage(titulo: string, mensaje: string, severity: string = 'info') {
    this.navServicio.setMesage(0, {
      severity: severity, summary: this.navServicio.buscarMensaje(titulo),
      detail: this.navServicio.buscarMensaje(mensaje)
    });
  }
}
